import type { JSX, ReactNode } from 'react';
import { EntityFilterBar } from '@/components/entity';

interface DashboardFilterBarProps {
  children: ReactNode;
  className?: string;
  containerClassName?: string;
  actions?: ReactNode;
}

export function DashboardFilterBar(props: DashboardFilterBarProps): JSX.Element {
  return <EntityFilterBar {...props} />;
}
